import { createFileRoute } from "@tanstack/react-router";
import DeTerms from "@/pages/legal/DeTerms";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/terms/")({
  head: () => routeHead("/de/terms/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DeTerms />
  );
}
